module.exports = __webpack_public_path__ + "static/media/centro_cordoba.932c86a4.png";